var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from "styled-components";
import padding from "@irati/ui/src/global/padding";
import Expander from "@irati/ui/src/Expander";
import { Card, Hr } from "@irati/ui/src/Layout";
export var SpacedCard = styled(Card)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: ", ";\n\n  ", "\n"], ["\n  margin-bottom: ", ";\n\n  ",
    "\n"])), padding.small, function (_a) {
    var theme = _a.theme, isInner = _a.isInner;
    return isInner && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-color: ", ";\n    box-shadow: ", ";\n  "], ["\n    background-color: ", ";\n    box-shadow: ", ";\n  "])), theme.colors.greys.lightest, theme.shadows.low);
});
export var AccordionExpander = styled(Expander)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: ", ";\n"], ["\n  padding: ", ";\n"])), function (_a) {
    var isInner = _a.isInner;
    return (isInner ? padding.small : padding.base);
});
export var AccordionContent = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 0 ", " ", " ", ";\n\n  ", "\n"], ["\n  padding: 0 ", " ", " ", ";\n\n  ", "\n"])), padding.base, padding.base, padding.base, function (_a) {
    var isInner = _a.isInner;
    return isInner && "padding: 0 " + padding.small + " " + padding.small + " " + padding.small + ";";
});
export var FlushTopHr = styled(Hr)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-top: 0;\n"], ["\n  margin-top: 0;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
